export default "ui-option-basic{justify-content:space-between}ui-option-basic.-control span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}\n";